import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-53285702"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "role-detail" }
const _hoisted_2 = { class: "role-detail-main" }
const _hoisted_3 = { style: {"height":"100%"} }
const _hoisted_4 = { style: {"height":"100%"} }
const _hoisted_5 = { style: {"height":"100%"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_page_header = _resolveComponent("el-page-header")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _directive_has = _resolveDirective("has")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_page_header, {
      onBack: _ctx.goBack,
      title: "返回上一级",
      content: "详情页面"
    }, null, 8 /* PROPS */, ["onBack"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        ref: "form",
        model: _ctx.model,
        "status-icon": "",
        rules: _ctx.rules,
        "label-width": "100px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "用户编码" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.model.code), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, {
            label: "用户名",
            prop: "name"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "text",
                modelValue: _ctx.model.name,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.model.name) = $event)),
                modelModifiers: { trim: true },
                placeholder: "请输入用户名",
                autocomplete: "off"
              }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, {
            label: "性别",
            prop: "gender"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: _ctx.model.gender,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.model.gender) = $event)),
                placeholder: "请选择性别"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.genderCodes, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8 /* PROPS */, ["label", "value"]))
                  }), 128 /* KEYED_FRAGMENT */))
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, {
            label: "手机号码",
            prop: "phoneNo"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "text",
                modelValue: _ctx.model.phoneNo,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.model.phoneNo) = $event)),
                autocomplete: "off",
                placeholder: "请输入手机号码"
              }, {
                prepend: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _ctx.model.phonePrefix,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.model.phonePrefix) = $event)),
                    style: {"width":"150px"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.countryAreaCodes, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.text), 1 /* TEXT */)
                          ]),
                          _: 2 /* DYNAMIC */
                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["label", "value"]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["modelValue"])
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, {
            label: "备注",
            prop: "remark"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                type: "text",
                modelValue: _ctx.model.remark,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.model.remark) = $event)),
                modelModifiers: { trim: true },
                autocomplete: "off",
                placeholder: "请输入备注"
              }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, { label: "状态" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$filters.statusFormat(_ctx.model.status)), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, { label: "创建时间" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$filters.dateFormat(_ctx.model.creationDate)), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }),
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              (_ctx.model.status==1)
                ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "success",
                    onClick: _ctx.enable
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("启用")
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["onClick"])), [
                    [_directive_has, void 0, "UpdateIMUserStatus"]
                  ])
                : _createCommentVNode("v-if", true),
              (_ctx.model.status==0)
                ? _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    type: "danger",
                    onClick: _ctx.disable
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("禁用")
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["onClick"])), [
                    [_directive_has, void 0, "UpdateIMUserStatus"]
                  ])
                : _createCommentVNode("v-if", true),
              _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                type: "primary",
                onClick: _ctx.save
              }, {
                default: _withCtx(() => [
                  _createTextVNode("保存")
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick"])), [
                [_directive_has, void 0, "UpdateIMUser"]
              ]),
              _createVNode(_component_el_button, { onClick: _ctx.goBack }, {
                default: _withCtx(() => [
                  _createTextVNode("返回上一级")
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["onClick"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["model", "rules"])
    ])
  ]))
}